import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});

export const styles = StyleSheet.create({
  page: {
    position: 'relative',
    paddingBottom: 40,
    flexDirection: 'column',
    alignItems: 'center',
  },
  backgroundContainer: {
    position: 'relative',
    width: '100%',
    height: 265,
  },
  backgroundImage: {
    position: 'absolute',
    objectFit: 'cover',
    width: '100%',
    height: 265,
  },
  overlayContent: {
    position: 'absolute',
    bottom: 20,
    left: 20,
    fontSize: 11,
    color: 'white',
    padding: 4,
  },
  title: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 40,
    fontWeight: 900,
    marginTop: 10,
    textTransform: 'uppercase',
    width: '100%',
  },
  lineBar: {
    borderTop: '5px solid white',
    width: 130,
    marginTop: 20,
  },

  contentWrapper: {
    marginTop: 20,
    marginLeft: 53,
    marginRight: 53,
  },
  listTitle: {
    color: 'black',
    fontFamily: 'Lato',
    fontSize: 11,
    marginRight: 53,
    marginBottom: 10,
  },
  inlineTextWrapper: {
    marginTop: 10,
  },
  listSubParagraphBold: {
    color: 'black',
    fontSize: 9,
    fontFamily: 'Lato',
    fontWeight: 900,
  },
  listSubParagraph: {
    color: 'black',
    fontSize: 9,
    fontFamily: 'Lato',
  },
  bulletItem: {
    color: 'black',
    fontSize: 9,
    lineHeight: 1.5,
    fontFamily: 'Lato',
    marginLeft: 10,
    marginRight: 10,
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 20,
  },
  button: {
    borderRadius: '4px',
    color: 'white',
    fontSize: 9,
    textDecoration: 'none',
    width: 'auto',
    paddingHorizontal: 10,
    paddingVertical: 4,
  },
  itemWrapper: {
    marginBottom: 2,
  },
  boldText: {
    color: 'black',
    fontSize: 9,
    lineHeight: 1.5,
    fontFamily: 'Lato',
    fontWeight: 900,
    marginBottom: 2,
  },
  text: {
    color: 'black',
    fontSize: 9,
    lineHeight: 1.5,
    fontWeight: 'thin',
  },

  downloadThePartnerBrochureWrapper: {
    backgroundColor: 'black',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 6,

    position: 'relative',
    width: '100%',
    height: '126px',
  },
  downloadImage: {
    position: 'absolute',
    objectFit: 'cover',
    width: '100%',
    height: '126px',
  },
  downloadThePartnerBrochureTitle: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 24,
    fontWeight: 900,
  },
  downloadThePartnerBrochureText: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 16,
  },
  downloadThePartnerBrochureButtonWrapper: {
    marginTop: 10,
    width: 'auto',
  },

  downloadThePartnerBrochureButton: {
    border: '2px solid white',
    borderRadius: 3,
    cursor: 'pointer',
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 12,
    textDecoration: 'none',
    textAlign: 'center',

    paddingVertical: 4,
    paddingHorizontal: 8,
  },

  testimonialsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginTop: 20,
    gap: 10,
  },

  testimonialBox: {
    border: '3px solid black',
    borderRadius: '5px',
    padding: 10,
    width: '30%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    fontFamily: 'Lato',
  },
  testimonialCitation: {
    fontSize: 11,
    fontWeight: 700,
    marginBottom: 6,
  },
  testimonialSpeaker: {
    fontSize: 9,
    fontWeight: 400,
  },
});
